import { takeEvery } from 'redux-saga'
import { call, put } from 'redux-saga/effects'
import fetcher from 'modules/fetcher'
// eslint-disable-next-line no-restricted-imports -- saga runs outside React render
import { t } from 'i18n/utils'
import { notify } from 'utils/notify'
import { PRELOAD_APP } from 'ducks'

import {
  accountUpdateFailure
} from './actions'

import {
  ACCOUNT_UPDATE_SUBMIT
} from './constants'

export function * accountUpdateSaga ({ payload }) {
  try {
    yield call(
      fetcher,
      'admin/account',
      {
        method: 'PATCH',
        body: JSON.stringify({
          account: {
            company_name: payload.companyName,
            technical_contact_email: payload.accountEmail,
            industry_id: payload.accountIndustry,
            address_autocompleter: payload.accountAddressAutocompleter
          }
        })
      }
    )

    // Default language is part of the same form Save. The endpoint is idempotent,
    // so it's safe to PUT every save; the alternative (diffing against prior
    // account.language in saga) requires threading state we don't have here.
    if (payload.language) {
      yield call(
        fetcher,
        'api/v3/admin/account_settings/language',
        {
          method: 'PUT',
          body: JSON.stringify({ value: payload.language })
        }
      )
    }

    yield call(notify, t('admin.account.sagas.saved'))
    yield put({ type: PRELOAD_APP })
  } catch (exception) {
    accountUpdateFailure(exception.message)
  }
}

export function * watchAccountUpdateSaga () {
  yield call(takeEvery, ACCOUNT_UPDATE_SUBMIT, accountUpdateSaga)
}
